import { render } from "./oap-make-the-switch-result-product.vue?vue&type=template&id=567b5cec"
import script from "./oap-make-the-switch-result-product.vue?vue&type=script&lang=js"
export * from "./oap-make-the-switch-result-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__